export default class Semaforo{

    IdSemaforo;
    Descrizione;
    QuantitaMinima;
    QuantitaMassima;

    constructor(){}

}